<template>
  <div :class="[classes.wrapperBadges]">
    <component
      :is="componentCard"
      :marketId="marketId"
      :eventId="eventId"
      class="h2h"
    />
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import { defineComponent, computed } from "vue";
import { injectLayout } from "../../../hooks/useLayout";
import { injectCarouselContext } from "../../../lib/provideInjectors";
import {
  BILLBOARD,
  injectTemplateSize,
  LARGE_RESPONSIVE
} from "@fresh8/ad-data-composition/src/useTemplateSize";
import MPU from "./badges/MPU.vue";
import LargeResponsive from "./badges/LargeResponsive.vue";
import { provideUseTeamBadges } from "../../../lib/teamBranding";
import { provideUseTeamJerseys } from "../../../lib/teamJerseys";

const useStyles = createUseStyles({
  wrapperBadges: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    flex: "1",
    boxSizing: "border-box",
    height: "100%"
  }
});

export default defineComponent({
  name: "InsightBadges",
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const classesRef = useStyles();
    const template = injectTemplateSize();
    const { layout } = injectLayout();
    const carouselContext = injectCarouselContext();

    provideUseTeamBadges(props.eventId);
    provideUseTeamJerseys(props.eventId);

    const componentCard = computed(() => {
      switch (template?.size.value.name) {
        case LARGE_RESPONSIVE.name:
          if (layout.value !== "squarish") {
            if (carouselContext.value.isCarousel) {
              return carouselContext.value.itemsOnView === 1
                ? LargeResponsive
                : MPU;
            }
            return LargeResponsive;
          }
          return MPU;
        case BILLBOARD.name:
          if (carouselContext.value.isCarousel) {
            return carouselContext.value.itemsOnView < 3
              ? LargeResponsive
              : MPU;
          }
          return LargeResponsive;
        default:
          return MPU;
      }
    });

    return {
      componentCard,
      classes: classesRef.value
    };
  }
});
</script>

<style></style>
